import { PlusOutlined } from '@ant-design/icons'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'

interface UploadFileButtonProps {
  className?: string
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const UploadFileButton: FunctionComponent<UploadFileButtonProps> = (props) => {
  const { formatMessage } = useIntl()

  return (
    <Button
      className={props.className}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <PlusOutlined />
      <Text>{formatMessage({ id: 'general:choose_file_cta' })}</Text>
    </Button>
  )
}

export const Button = styled.button`
  align-items: center;
  background: #fafafa;
  border-radius: 2px;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  display: flex;
  height: 102px;
  justify-content: center;
  width: 102px;

  > .anticon {
    width: 16px;
    height: 16px;
  }

  > :not(:last-child) {
    margin: 0 4px 0 0;
  }
`

const Text = styled.p`
  color: ${({ theme }): string => theme.colors.text.secondary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
`

export default styled(UploadFileButton)``
